import React, { useEffect, useState } from 'react';
import { Timeline, Collapse, Skeleton, Empty } from 'antd';
import { PlusCircleOutlined, MinusCircleOutlined, DownOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { JSONTree } from 'react-json-tree';
import http from '../../utils/http';
import moment from 'moment';
import './assets/style.css';
import { useLocation } from 'react-router-dom';
import { Breadcrumbs } from '../../components/Atom/breadcumbs';
import { formatAmount, getFormattedDateForApiLogs } from 'utils/services';
import ShortenId from 'components/Atom/ShortenId';
import StatusTag from 'components/Atom/StatusTag';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { ResetButton } from '../../components/Atom/Button';
import { useSelector } from 'react-redux';
import LoadingSkeleton from '../../components/Skeleton/index';
import CopyToClipboardButton from 'components/CopyToClipboardButton';
import { TIMEZONES, theme } from 'utils/constant';
import { formatInTimeZone } from 'date-fns-tz';
const { Panel } = Collapse;
const ViewIntentData = () => {
  const [showDetails, setDetails] = useState(null);
  const [apiLogs, setApiLogs] = useState(null);
  const [webhookLogs, setWebhookLogs] = useState(null);
  const [refundLogs, setRefundLogs] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const store = useSelector((state) => state.company.store);
  const { id } = useParams();

  const fetchPaymentIntentData = async () => {
    const storeId = location?.state?.record?.store_id || store?._id;
    const paymentIntent_id = id || location?.state?.record?._id;
    const response = await http.get(`/public/v1/payment/intent/data?search_key=${paymentIntent_id}&store_id=${storeId}`);
    const data = response?.data?.data?.docs[0];
    /* if (data) {
      getPIRedisData(data);
    } */
    return data;
  };

  const {
    data: record,
    refetch,
    isLoading,
    isFetching,
  } = useQuery(`paymentIntent_${id || location?.state?.record?.product_id}`, fetchPaymentIntentData, {
    enabled: false,
    manual: true,
  });
  useEffect(() => {
    refetch();
  }, [store]);

  useEffect(() => {
    if (record) getPIRedisData(record);
  }, [record]);

  const time_zone = store?.settings?.timezone || TIMEZONES.PKT;
  const structuredData = (item) => {
    const summary = {
      customerDetails: [
        { label: 'Customer Name', value: item?.customer?.name },
        { label: 'Email', value: item?.customer?.email ?? 'N/A' },
        { label: 'Phone Number', value: item?.customer?.phone ?? 'N/A' },
        { label: 'VIP Customer', value: item?.customer?.vip_customer ?? 'N/A' },
        { label: 'Previous Customer', value: item?.customer?.previous_customer ?? 'N/A' },
        {
          label: 'Shipping Address',
          value: item?.shipping?.address1 ?? item?.payment_intent_id?.shipping?.address2 ?? 'N/A',
        },
        {
          label: 'ZIP Code',
          value: item?.shipping?.zip ?? 'N/A',
        },
        {
          label: 'City',
          value: item?.shipping?.city ?? 'N/A',
        },
        {
          label: 'Province',
          value: item?.shipping?.province ?? 'N/A',
        },
        {
          label: 'Country',
          value: item?.payment_intent_id?.shipping?.country ?? 'N/A',
        },
      ],
      transactionDetails: [
        { label: 'Intent Id', value: <ShortenId value={item?._id} /> },
        { label: 'Status', value: <StatusTag tag={item?.status?.toUpperCase()} /> || 'N/A' },
        { label: 'Order Id', value: item?.metadata?.order_reference ?? 'N/A' },
        { label: 'Order Source', value: item?.metadata?.source || 'N/A' },
        {
          label: `Order Amount`,
          value: `${item?.currency} ${formatAmount(item?.original_amount, item?.currency)}`,
        },
        {
          label: item?.capture_method && item?.capture_method == 'manual' ? `Authorized Amount` : 'Paid Amount',
          value: `${item?.currency} ${formatAmount(item?.amount, item?.currency)}`,
        },
        ...(item?.captured_amount && item?.captured_amount != undefined
          ? [
              {
                label: `Captured Amount`,
                value: `${item?.currency} ${formatAmount(Number(item?.captured_amount) || item?.amount, item?.currency)}`,
              },
            ]
          : []),
        { label: `Gateway ID`, value: `${item?.gateway_instance_id ?? 'N/A'}` },
        { label: `Refunded Amount`, value: `${item?.currency} ${formatAmount(item?.refund_data?.refunded_amount, item?.currency)}` },
        { label: 'Confirmed', value: item?.confirm ? 'True' : 'False' },
        { label: 'Capture Method', value: item?.capture_method?.toUpperCase() ?? 'N/A' },
        { label: 'Creation Time', value: item?.created_at ? formatInTimeZone(item?.created_at, time_zone, 'MMM d, yyyy h:mm:ss a') : '-' },
        { label: 'Last Update Time', value: item?.last_update ? formatInTimeZone(item?.last_update, time_zone, 'MMM d, yyyy h:mm:ss a') : 'Not Set' },
        { label: 'Payment Method Type', value: item?.payment_method_types?.toUpperCase() ?? 'N/A' },
        { label: 'Last Response Status', value: item?.last_payment_response?.status ?? 'N/A' },
        { label: 'Last Response Message', value: item?.last_payment_response?.message ?? 'N/A' },
        { label: 'Last Response Code', value: item?.last_payment_response?.code ?? 'N/A' },
        { label: 'Transaction Reference', value: item?.transaction_reference ?? 'N/A' },
      ],
      ...(item?.apply_bin_discount &&
        item?.amount_summary &&
        item?.amount_summary !== undefined &&
        Object.keys(item?.amount_summary)?.length > 0 && {
          binDiscountDetails: [
            {
              label: `Base Amount`,
              value: `${item?.currency} ${formatAmount(item?.original_amount, item?.currency)}`,
            },
            {
              label: `Discount`,
              value: `${formatAmount(item?.applied_bin_discount_details?.value, item?.currency)} ${item?.applied_bin_discount_details?.type === 'percentage' ? '%' : ''}`,
            },
            {
              label: `Discount Capped`,
              value: `${formatAmount(item?.applied_bin_discount_details?.limit, item?.currency)}`,
            },
            {
              label: `Discounted Amount`,
              value: `${item?.currency} ${formatAmount(item?.discount_applied, item?.currency)}`,
            },
            {
              label: `Tax Type`,
              value: item?.tax_info?.type ? <StatusTag tag={item?.tax_info?.type?.toUpperCase()} {...(item?.tax_info?.type === 'exclusive' && { color: 'orange' })} /> : 'N/A',
            },
            {
              label: `Tax Rate`,
              value: `${formatAmount(item?.tax_info?.rate)}%`,
            },
            {
              label: `Tax Amount`,
              value: `${item?.currency} ${formatAmount(item?.amount_summary?.tax_amount)}`,
            },
            {
              label: `Additional Charges`,
              value: ['exclusive', 'after_discount'].includes(item?.tax_info?.type) ? `${item?.currency} ${formatAmount(item?.amount_summary?.additional_charges)}` : 'N/A',
            },
            {
              label: `Total After Discount`,
              value: `${item?.currency} ${formatAmount(item?.amount_summary?.total_after_discount)}`,
            },
          ],
        }),
    };
    const details = {
      activity: item?.activity,
      webhook_data: item?.webhook_data ?? null,
      api_log: item?.api_log ?? null,
      pi_id: item?._id,
      status: item?.status,
      paymentResponse: item?.last_payment_response,
      payment_message: item?.last_payment_response?.message,
    };
    return { details, summary };
  };

  const { details: refundData, summary: data } = structuredData(record);

  const onClickHandle = (key, value) => {
    setDetails((pre) => ({ ...pre, [key]: value }));
  };
  const getPIRedisData = async (data) => {
    try {
      const paymentIntent_id = id || data?._id;
      const storeId = data?.store_id;
      const { start_date, end_date } = getFormattedDateForApiLogs(data);
      const response = await http.get(`/public/v1/payment/intent/cloudwatch/${paymentIntent_id}/logs?store_id=${storeId}&start_date=${start_date}&end_date=${end_date}`);
      setApiLogs(response?.data?.data?.logs || refundData?.api_log || null);
      setWebhookLogs(response?.data?.data?.webhook || refundData?.webhook_data || null);
      setRefundLogs(response?.data?.data?.refund || null);
    } catch (err) {}
  };

  const isNewWebhookLogFormat = (data) => data?.webhook_data !== undefined && data?.webhook_response !== undefined;

  const getWebhookLogDisplayData = (data) => {
    const displayData = { ...data };
    if (displayData?._id) {
      delete displayData._id;
    }
    return displayData;
  };

  const formatWebhookTime = (value) => {
    if (!value) return 'N/A';
    return formatInTimeZone(value, time_zone, 'MMM d, yyyy h:mm:ss a');
  };

  const getApiLogCopyContent = (data) => ({
    'Request Time': moment(data?.created_at).format('MMM D, YYYY h:mm:ss A'),
    'Request Body': data?.payload ?? null,
    'Response Body': data?.response ?? null,
  });

  const renderWebhookResponseBody = (response, index) => {
    if (response === null || response === undefined) {
      return <JSONTree key={`${index}-response`} data={null} theme={theme} invertTheme={true} hideRoot={true} />;
    }

    if (typeof response === 'string') {
      return (
        <pre
          key={`${index}-response`}
          style={{
            margin: '5px 0px',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            fontSize: '14px',
            fontFamily: 'inherit',
          }}>
          {response}
        </pre>
      );
    }

    if (typeof response === 'object') {
      return <JSONTree key={`${index}-response`} data={response} theme={theme} invertTheme={true} hideRoot={true} />;
    }

    return (
      <pre key={`${index}-response`} style={{ margin: '5px 0px', whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: '14px' }}>
        {String(response)}
      </pre>
    );
  };

  const renderWebhookLogContent = (data, index) => {
    if (isNewWebhookLogFormat(data)) {
      return (
        <>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <CopyToClipboardButton content={data} />
          </div>
          <p style={{ margin: '5px 0px' }}>
            <h1 style={{ fontWeight: 'bold' }}>URL:</h1> {data?.webhook_response?.endpoint?.trim() || 'N/A'}
          </p>
          <p style={{ margin: '5px 0px' }}>
            <h1 style={{ fontWeight: 'bold' }}>Webhook Trigger Time:</h1> {formatWebhookTime(data?.webhook_response?.webhook_trigger_time)}
          </p>
          <p style={{ margin: '5px 0px' }}>
            <h1 style={{ fontWeight: 'bold' }}>Webhook Response Time:</h1> {formatWebhookTime(data?.webhook_response?.webhook_response_time)}
          </p>
          <h1 style={{ fontWeight: 'bold', margin: '5px 0px' }}>Request Body</h1>
          <JSONTree key={`${index}-request`} data={data?.webhook_data ?? null} theme={theme} invertTheme={true} hideRoot={true} />
          <h1 style={{ fontWeight: 'bold', margin: '5px 0px' }}>Response Body</h1>
          {renderWebhookResponseBody(data?.webhook_response?.response, index)}
        </>
      );
    }

    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <CopyToClipboardButton content={data} />
        </div>
        <JSONTree key={index} data={getWebhookLogDisplayData(data)} theme={theme} invertTheme={true} hideRoot={true} />
      </>
    );
  };

  const renderWebhookLogHeader = (data, index) => {
    if (isNewWebhookLogFormat(data)) {
      const statusCode = data?.webhook_response?.status_code;
      const statusLabel = statusCode !== undefined && statusCode !== null ? `[${statusCode}] ` : '';

      return (
        <div className='header-api-log'>
          <span className='request-type'>{`Webhook Request ${index + 1}: ${data?.webhook_response?.message || data?.webhook_data?.status}${statusLabel}`}</span>
        </div>
      );
    }

    return (
      <div className='header-api-log'>
        <span className='request-type'>{`Webhook Request ${index + 1}`}</span>
      </div>
    );
  };

  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Payment Intent',
        href: '/paymentIntent',
        data: { id: location?.state?.id, isRedirection: true, filtersData: location?.state?.filtersData, searchValue: location?.state?.searchValue },
      },
      {
        name: <ShortenId value={id || location?.state?.id || 'Not Found'} />,
      },
    ],
  };

  const assignOrderStatusColor = (text) => {
    const e = text?.toUpperCase();
    if (e === 'TIMEOUT' || e === 'CANCELLED') {
      return 'yellow';
    } else if (e === 'FAILED' || e === 'AUTHENTICATION_NOT_SUPPORTED' || e === 'AUTHENTICATION_FAILED' || e === 'AUTHORIZATION_DECLINED' || e === 'AUTHENTICATION_REJECTED') {
      return 'red';
    } else if (e === 'AUTHENTICATION_PENDING' || e === 'PENDING') {
      return 'gray';
    } else if (e === 'REFUNDED' || e === 'PARTIALLY_REFUNDED') {
      return 'blue';
    } else {
      return 'green';
    }
  };
  let cardDetails = null;
  if (refundData?.activity?.length > 0) {
    const capturePaymentData = refundData?.activity?.filter((obj) => obj?.status == 'CAPTURED');
    cardDetails = capturePaymentData[0]?.status ? capturePaymentData[0] : refundData?.activity[0];
  }

  const cardInfoData = (cardDetails) => {
    const cardInfo = [
      { label: 'Name', value: cardDetails?.card?.name ?? 'N/A' },
      { label: 'Card Number', value: cardDetails?.card?.number ?? 'N/A' },
      { label: 'Funding Method', value: cardDetails?.card?.funding_method?.toUpperCase() ?? 'N/A' },
      { label: 'Card Type', value: cardDetails?.card?.type?.toUpperCase() ?? 'N/A' },
      { label: 'Authorization Code', value: cardDetails?.authorizationCode ? cardDetails?.authorizationCode : 'N/A' },
      { label: 'Card Version', value: cardDetails?.secure?.toUpperCase() ?? 'N/A' },
      { label: 'Card Issuer', value: cardDetails?.issuerDetails?.card_issuer ?? 'N/A' },
      { label: 'Card Network', value: cardDetails?.issuerDetails?.card_network ?? 'N/A' },
      ...(cardDetails?.eci
        ? [
            { label: 'ECI', value: cardDetails?.eci?.toUpperCase() ?? 'N/A' },
            { label: 'CAVV', value: cardDetails?.cavv?.toUpperCase() ?? 'N/A' },
            { label: 'XID', value: cardDetails?.xid?.toUpperCase() ?? 'N/A' },
            { label: 'AVS Code', value: cardDetails?.avsCode?.toUpperCase() ?? 'N/A' },
            { label: 'Reference Number', value: cardDetails?.retrievalReferenceNumber?.toUpperCase() ?? 'N/A' },
            { label: 'Acquirer Transaction Id', value: cardDetails?.acquirerTransactionId?.toUpperCase() ?? 'N/A' },
          ]
        : [{ label: 'Terminal Id', value: cardDetails?.terminal ?? 'N/A' }]),
    ];
    return cardInfo;
  };
  return (
    <div>
      <div className='header-container p-4 custom-sticky'>
        <div className='payment-breadcrums' style={{ marginBottom: '15px' }}>
          <div
            className='back-button'
            onClick={() =>
              navigate('/paymentIntent', {
                state: {
                  id: location?.state?.id,
                  isRedirection: true,
                  filtersData: location?.state?.filtersData,
                  searchValue: location?.state?.searchValue,
                },
              })
            }>
            <ArrowLeftOutlined /> <span style={{ fontWeight: 600 }}>Back</span>
          </div>
          <span style={{ color: '#8C8C8C' }}>|</span>
          <Breadcrumbs {...breadcrumbProps} />
          <ResetButton onClick={refetch} loading={isFetching} />
        </div>
        <div className='detail-heading mb-4'>Payment Intent Detail</div>
        <div className='headerPage' style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
          <div className='payment-message' style={{ display: 'flex' }}>
            {isLoading ? <Skeleton.Input className='status-skeleton' /> : refundData?.status && <div className='header-tag'>{<StatusTag tag={refundData?.status} /> || 'N/A'}</div>}
            {isLoading ? (
              <Skeleton.Input className='message-skeleton' />
            ) : (
              refundData?.paymentResponse && (
                <div style={{ width: '100%' }}>
                  <div className='message' style={{ padding: '6.2px 12px', marginLeft: '6px', borderRadius: '8px' }}>
                    {refundData?.payment_message}
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className='custom-panel breakWord' style={{ marginTop: '20px' }}>
        <div className='logs-details'>
          {isLoading ? (
            <LoadingSkeleton />
          ) : !record ? (
            store?.isSelected ? (
              <div className='empty-custom-style'>
                <Empty image={Empty?.PRESENTED_IMAGE_SIMPLE} />
              </div>
            ) : (
              <div className='empty-custom-style'>
                <Empty description={'Select store from the drop-down menu above'} />
              </div>
            )
          ) : (
            <>
              <div className='Customer-Details details-section'>
                <div className='heading-section'>
                  <h3>Intent Details</h3>
                </div>

                <div className='detail-card'>
                  {data?.transactionDetails?.map((info, index) => (
                    <div key={index} className='detail-value'>
                      <h2>{info?.label}</h2> <span>{info?.value || 'N/A'}</span>
                    </div>
                  ))}
                </div>
              </div>

              {data?.binDiscountDetails?.length > 0 && (
                <div className='Customer-Details details-section'>
                  <div className='heading-section'>
                    <h3>Bin Discount Details</h3>
                  </div>

                  <div className='detail-card'>
                    {data?.binDiscountDetails?.map((info, index) => (
                      <div key={index} className='detail-value'>
                        <h2>{info?.label}</h2> <span>{info?.value || 'N/A'}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className='Customer-Details details-section'>
                <div className='heading-section'>
                  <h3>Customer Details</h3>
                </div>

                <div className='detail-card'>
                  {data?.customerDetails?.map((info, index) => (
                    <div key={index} className='detail-value'>
                      <h2>{info?.label}</h2> <span>{info?.value || 'N/A'}</span>
                    </div>
                  ))}
                </div>
              </div>
              {cardDetails && (
                <div className='Card-details details-section'>
                  <div className='heading-section'>
                    <h3>Card details</h3>
                  </div>
                  <div className='detail-card'>
                    {cardInfoData(cardDetails)?.map((info, index) => (
                      <div key={index} className='detail-value'>
                        <h2>{info?.label}</h2> <span>{info?.value || 'N/A'}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {refundData?.activity?.length > 0 && (
                <div className='Timeline details-section'>
                  <div className='heading-section'>
                    <h3>Timeline</h3>
                  </div>
                  <Timeline style={{ marginTop: '6px', padding: '20px' }}>
                    {refundData?.activity.map((obj, index) => {
                      return (
                        obj?.status && (
                          <Timeline.Item color={assignOrderStatusColor(obj?.status)} style={{ marginBottom: '-18px' }} key={index}>
                            <p className='font-semibold detailBtn'>
                              <span>{obj?.status === 'AUTHORIZED_DECLINED' ? 'AUTHORIZATION_DECLINED' : (obj?.status ?? '')}</span>
                              {obj?.status !== 'PARTIALLY_REFUNDED' && obj?.status !== 'REFUNDED' && (
                                <>
                                  {Object.keys(showDetails ?? {})?.length > 0 && showDetails[index] == index ? (
                                    <MinusCircleOutlined style={{ fontSize: '15px', marginLeft: '1.5%', color: '#000000' }} onClick={() => onClickHandle(index, null)} />
                                  ) : (
                                    <PlusCircleOutlined style={{ fontSize: '15px', marginLeft: '1.5%', color: '#000000' }} onClick={() => onClickHandle(index, index)} />
                                  )}
                                </>
                              )}
                            </p>
                            {Object.keys(showDetails ?? {})?.length > 0 && showDetails[index] == index ? (
                              <div className='detail-card' style={{ padding: '0' }}>
                                {cardInfoData(obj)?.map((info, index) => (
                                  <div key={index} className='detail-value'>
                                    <h2>{info?.label}</h2> <span>{info?.value || 'N/A'}</span>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <>
                                <p style={{ margin: '3px 0px', fontSize: '14px' }}>{moment(obj?.timestamp).format('MMM D, YYYY h:mm:ss A')}</p>
                                {(obj?.status === 'PARTIALLY_REFUNDED' || obj?.status === 'REFUNDED') && obj?.refundReason && (
                                  <p style={{ margin: '3px 0px', fontSize: '14px' }}>
                                    <b>Refund Reason: </b>
                                    {obj?.refundReason}
                                  </p>
                                )}
                              </>
                            )}
                          </Timeline.Item>
                        )
                      );
                    })}
                  </Timeline>
                </div>
              )}
              <Collapse expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />} defaultActiveKey={['5', '6']}>
                {webhookLogs && webhookLogs?.length > 0 && (
                  <Panel header='Webhook Logs' className='border' key='5'>
                    <div className='webhookLogs'>
                      <Collapse>
                        {webhookLogs?.map((data, index) => (
                          <Panel header={renderWebhookLogHeader(data, index)} className='border' key={`webhook-${data?.id || index}`}>
                            <div>{renderWebhookLogContent(data, index)}</div>
                          </Panel>
                        ))}
                      </Collapse>
                    </div>
                  </Panel>
                )}
                {apiLogs?.length > 0 && (
                  <Panel header='API Logs' className='border' key='6'>
                    <div className='apiLogs'>
                      <Collapse>
                        {apiLogs?.map((data, index) => {
                          if (data?.response?.encryptionKey) {
                            delete data?.response?.encryptionKey;
                          }
                          return (
                            <Panel
                              header={
                                <div className='header-api-log'>
                                  <h1>{data?.end_point_url}</h1>
                                  <span className='request-type'>{data?.api_call_name}</span>
                                </div>
                              }
                              className='border'
                              key={`${index}1`}>
                              <div className=''>
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                  <CopyToClipboardButton content={getApiLogCopyContent(data)} />
                                </div>
                                <h1 style={{ fontWeight: 'bold' }}>Request Time</h1>
                                <p style={{ margin: '5px 0px' }}>{moment(data?.created_at).format('MMM D, YYYY h:mm:ss A')}</p>
                                <h1 style={{ fontWeight: 'bold', margin: '5px 0px' }}>Request Body</h1>
                                <JSONTree key={`${index}2`} data={data?.payload ?? null} theme={theme} invertTheme={true} hideRoot={true} />
                                <h1 style={{ fontWeight: 'bold', margin: '5px 0px' }}>Response Body</h1>
                                <JSONTree key={`${index}3`} data={data?.response ?? null} theme={theme} invertTheme={true} hideRoot={true} />
                              </div>
                            </Panel>
                          );
                        })}
                      </Collapse>
                    </div>
                  </Panel>
                )}
                {refundLogs?.length > 0 && (
                  <Panel header='Refund Logs' className='border' key='7'>
                    <div className='apiLogs'>
                      <Collapse>
                        {refundLogs?.map((data, index) => {
                          if (data?.response?.encryptionKey) {
                            delete data?.response?.encryptionKey;
                          }
                          return (
                            <Panel
                              header={
                                <div className='header-api-log'>
                                  <h1>{data?.end_point_url}</h1>
                                  <span className='request-type'>{data?.api_call_name}</span>
                                </div>
                              }
                              className='border'
                              key={`${index}1`}>
                              <div className=''>
                                <h1 style={{ fontWeight: 'bold' }}>Request Time</h1>
                                <p style={{ margin: '5px 0px' }}>{moment(data?.created_at).format('MMM D, YYYY h:mm:ss A')}</p>
                                <h1 style={{ fontWeight: 'bold', margin: '5px 0px' }}>Request Body</h1>
                                <JSONTree key={`${index}2`} data={data?.payload ?? null} theme={theme} invertTheme={true} hideRoot={true} />
                                <h1 style={{ fontWeight: 'bold', margin: '5px 0px' }}>Response Body</h1>
                                <JSONTree key={`${index}3`} data={data?.response ?? null} theme={theme} invertTheme={true} hideRoot={true} />
                              </div>
                            </Panel>
                          );
                        })}
                      </Collapse>
                    </div>
                  </Panel>
                )}
              </Collapse>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default ViewIntentData;
